/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function(event){

    // GSAP matchMedia
    var mm = gsap.matchMedia();

    // GSAP logos animations
    var logosContainer = document.querySelector('.wp-block-create-block-mq20-logo-wall');
    var logosParagraph = document.querySelector('.wp-block-create-block-mq20-logo-wall p');
    var logosButton = document.querySelector('.wp-block-create-block-mq20-logo-wall .action_button');
    var logosItems = gsap.utils.toArray('.logo-wall-logo-item');

    function initLogoScrollAnimation(){
        const logoAnimationTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: logosContainer,
                start: "top +=90%",
                end: "bottom bottom"
            },
        });

        logoAnimationTimeline.from(logosParagraph, {
            y: 20,
            opacity: 0,
            duration: 0.2,
            ease: "power3.inOut",
            delay: 0.3
        }).from(logosButton, {
            y: 20,
            opacity: 0,
            duration: 0.2,
            ease: "power3.inOut"
        });

        var animationProperties = {
            opacity: 0,
            duration: 1,
            scrollTrigger: {
                trigger: logosContainer,
                start: "top +=85%",
                end: "bottom bottom",
                ease: "power3.inOut",
                stagger: 0.2
            }
        };

        mm.add("(min-width: 1025px)", () => {
            logosItems.forEach(function(logosItem, index) {
                var delay = (index % 7) * 0.2;
                gsap.from(logosItem, {
                    ...animationProperties,
                    y: 20,
                    delay: delay
                });
            });
        });

        mm.add("(max-width: 1024px)", () => {
            logosItems.forEach(function(logosItem, index) {
                var delay = (index % 3) * 0.2;
                gsap.from(logosItem, {
                    ...animationProperties,
                    y: 20,
                    delay: delay
                });
            });
        });
    }

    mm.add("(min-width: 1024px)", function() {
        initLogoScrollAnimation();
    });
});
